import React, { Component } from 'react';

class SprachtestPostMsg extends React.Component {

    componentDidMount() {
        const script = document.createElement("script");
        script.async = true;
        script.src = "https://sprachtest.local.de/themes/custom/sprachtest_frontend/js/sprachtest_zeit.js";
        document.body.appendChild(script);
    }
    render(){
        return(
          <div></div>
        );
    }
}
export default SprachtestPostMsg;
